import { Icon as KuiperIcon } from '@opallabs/kuiper'
import {
  cardDividerStyles,
  cardGenericStyles,
  cardIconStyles,
  cardLineItemStyles,
  cardMediaStyles,
  cardStyles,
  cardSubtitleStyles,
  cardTitleStyles,
} from './styles'
import { CardIconProps, CardMediaProps, CardProps } from './types'

interface CardComponent {
  Title: React.FunctionComponent<React.PropsWithChildren<CardProps>>
  Subtitle: React.FunctionComponent<React.PropsWithChildren<CardProps>>
  Media: React.FunctionComponent<CardMediaProps>
  LineItem: React.FunctionComponent<React.PropsWithChildren<CardProps>>
  Icon: React.FunctionComponent<CardIconProps>
  Generic: React.FunctionComponent<React.PropsWithChildren<CardProps>>
  Divider: React.FunctionComponent<CardProps>
}

const Title: React.FC<React.PropsWithChildren<CardProps>> = ({
  cssOverride,
  children,
}) => <h1 css={[cardTitleStyles, cssOverride]}>{children}</h1>

const Subtitle: React.FC<React.PropsWithChildren<CardProps>> = ({
  cssOverride,
  children,
}) => <h2 css={[cardSubtitleStyles, cssOverride]}>{children}</h2>

const Media: React.FC<CardMediaProps> = ({
  imgSource,
  cssOverride,
  altText = 'Card Media Image',
}) => <img css={[cardMediaStyles, cssOverride]} src={imgSource} alt={altText} />

const LineItem: React.FC<React.PropsWithChildren<CardProps>> = ({
  cssOverride,
  children,
}) => <div css={[cardLineItemStyles, cssOverride]}>{children}</div>

const Icon: React.FC<CardIconProps> = ({
  cssOverride,
  iconName,
  iconSize = 20,
}) => (
  <div css={cssOverride}>
    <KuiperIcon
      height={iconSize}
      width={iconSize}
      glyph={iconName}
      system="gem"
    />
  </div>
)

const Generic: React.FC<React.PropsWithChildren<CardProps>> = ({
  cssOverride,
  children,
}) => <div css={[cardGenericStyles, cssOverride]}>{children}</div>

const Divider: React.FC<CardProps> = ({ cssOverride }) => (
  <div css={[cardDividerStyles, cssOverride]} />
)

const SimpleCard: CardComponent &
  React.FC<React.PropsWithChildren<CardProps>> = ({
  cssOverride,
  children,
}) => <div css={[cardStyles, cardIconStyles, cssOverride]}>{children}</div>

SimpleCard.Title = Title
SimpleCard.Subtitle = Subtitle
SimpleCard.Media = Media
SimpleCard.LineItem = LineItem
SimpleCard.Icon = Icon
SimpleCard.Generic = Generic
SimpleCard.Divider = Divider

export { SimpleCard }
